import type { FC } from 'react';
import classNames from 'classnames';

import { cssVariable } from 'app/utils/style';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  size?: number;
}

const CircleLoader: FC<Props> = ({ size = 14, className }) => (
  <div
    style={cssVariable('size', `${size}px`)}
    className={classNames(style.circularLoader, className)}
  />
);

CircleLoader.displayName = 'CircleLoader';

export default CircleLoader;
